module.exports = __webpack_public_path__ + "img/true.d39edb7.png";